<mat-card-header>
  <mat-toolbar class="toolbar">
    <mat-card-title style="font-size: 20px; font-weight: bold; font-family: 'Times New Roman', Times, serif;">{{ 'reservationList' | translate }} {{voyageid}}</mat-card-title>
    <span class="toolbar-spacer"></span>

    <!-- <mat-icon (click)="addagence()">add</mat-icon> -->
    <!-- <ng-container *ngIf="userprivileges[4].state"> -->

      <button mat-mini-fab color="primary" title="{{ 'ajouteReservation' | translate }} "
       (click)="addReservation()">
        <mat-icon >perm_contact_calendar</mat-icon>
      </button>
    <!-- </ng-container> -->
  </mat-toolbar>
</mat-card-header>

<div class="container">
  <mat-form-field>
      <input matInput  placeholder="{{ 'search_users_placeholder' | translate }}">
  </mat-form-field>

  <!-- table display content here-->
  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>

         <!-- ID Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> No. </th>
          <td mat-cell *matCellDef="let element; let i=index;"> {{i+1}} </td>
        </ng-container>

           <!-- Name Column -->
          <ng-container matColumnDef="ticket">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'ticket' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.idreservation}} </td>
         </ng-container>

           <!-- Name Column -->
          <ng-container matColumnDef="passager">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'reservation' | translate}} </th>
              <td mat-cell *matCellDef="let row"> {{row.nomclient}} </td>
          </ng-container>

          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'table_headers.phone' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.contact}} </td>
          </ng-container>

          <ng-container matColumnDef="destination">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'destination' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.voyage.destination[0]?.ville?.nomville}} </td>
          </ng-container>

          <ng-container matColumnDef="category">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'category' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.voyage.category.nomcategory}} </td>
          </ng-container>

          <ng-container matColumnDef="bus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'table_headers.bus' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.voyage.busname==null?row.voyage.nomvoyage:row.voyage.busname}} </td>
          </ng-container>
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'Date' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.creationdate | date:"dd-MM"}} </td>
          </ng-container>

          <ng-container matColumnDef="tarif">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'table_headers.tarif' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.voyage.tarif.tarif}} </td>
          </ng-container>

          <ng-container matColumnDef="siege">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'siege' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.place}} </td>
          </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'action' | translate}} </th>
        <td mat-cell *matCellDef="let element">
              <!-- <ng-container>
                <a (click)="viewVoyagePassenger(element)" class="accent"><i style="color: rgb(9, 11, 121);" class="material-icons">remove_red_eye</i></a>
              </ng-container> -->

            <!-- <ng-container *ngIf="userprivileges[6].state"> -->
              <a (click)="getreservationdata(element)" class="accent"><i style="color: green;" class="material-icons">check_circle</i></a>
            <!-- </ng-container> -->
            <!-- <ng-container *ngIf="userprivileges[7].state"> -->
              <a (click)="delete(element)" title="supprimer"><i style="color: red;" class="material-icons">cancel</i></a>
              <!-- <a (click)="delete(element)" title="supprimer"><i style="color: blue;" class="material-icons">refresh</i></a> -->
            <!-- </ng-container> -->
        </td>
    </ng-container>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          No records found.
        </td>
      </tr>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"  ></tr>
        <tr class="example-element-row" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 25, 100,reservationlist?.totalElements]" (page)="nextPage($event)" [length]="reservationlist?.totalElements"
    showFirstLastButtons></mat-paginator>
  </div>

</div>
